import React from 'react';
// Moment library size is very high 100kb zipped and minified

// import { format } from 'date-fns';
import PropTypes from 'prop-types';
import Login from 'components/Login';
import ErrorBoundary from 'components/ErrorBoundary';
import WithGeo from 'helpers/ads/WithGeo';
import WithTimesPoint from 'modules/WithTimesPoint';
import WithTimesPointModal from 'modules/WithTimesPointModal';
import WithNotificationCenter from 'modules/WithNotificationCenter';
import Link from 'components/Link';
import { ENT_CITY_TO_STATE_API } from 'constants/index';
import makeRequest from 'utils/makeRequest';
import CookieObj from '../,,/../../../common/EducationWidget/helper';
import CityModal from '../CityModal/CityModal';
import Timsedition from '../Timsedition/Timsedition';
import SnackPopup from '../SnackPopup/SnackPopup';
import s from './TopBar.scss';
import WithSocials from '../Socials/WithSocials';

class TopBar extends React.Component {
  constructor() {
    super();
    this.state = {
      showCityPopup: false,
      entCity: '',
      entState: '',
      citytext: '',
      poweredBy: undefined,
    };
  }

  componentDidMount() {
    let cityName = CookieObj.get_cookie('geolocation');
    cityName = cityName || 'Delhi';
    this.loadTopCityData(cityName);
  }

  loadTopCityData(cityName) {
    makeRequest
      .get(`${ENT_CITY_TO_STATE_API}${cityName}`, {}, 'skipfeedengine')
      .catch(err => console.log(err))
      .then(data => {
        if (data && data.status === 200 && data.data && data.data.item) {
          this.changeTopBarCity(data.data.item);
        }
      });
  }

  toggleModal = e => {
    e.preventDefault();
    this.setState({ showCityPopup: !this.state.showCityPopup });
  };

  changeTopBarCity = (city, saveInCookie = false) => {
    this.setState({
      entCity: city.name,
      entState: city.state,
      citytext: city.citytext,
      poweredBy:
        typeof city.poweredBy !== 'undefined' ? city.poweredBy : undefined,
    });
    if (saveInCookie) {
      CookieObj.set_cookie('geolocation', city.name, 30);
    }
  };

  render() {
    const { colorTheme } = this.props;
    const {
      showCityPopup,
      entCity,
      entState,
      poweredBy,
      citytext,
    } = this.state;
    const theme = colorTheme ? s[colorTheme] : '';

    return (
      <div
        id="top-bar-container"
        className={`${s['top-area']} ${theme} top-area `}
      >
        {citytext && citytext !== '' && <Timsedition citytext={citytext} />}
        {showCityPopup && (
          <CityModal
            toggleModal={this.toggleModal}
            changeTopBarCity={this.changeTopBarCity}
            entCity={entCity}
            entState={entState}
          />
        )}
        <div className="contentwrapper">
          <div className={`${s.row} rel`}>
            <div className={s.column}>
              <div className={s.urcityselect}>
                <Link onClick={this.toggleModal}>
                  <i />
                  {entCity && <span>{entCity}</span>}
                </Link>{' '}
                {entState && <span>({entState})</span>}
                <SnackPopup />
              </div>
              {typeof poweredBy !== 'undefined' && (
                <div className={s.pweredtxt}>
                  Powered by <span>{poweredBy.name}</span>{' '}
                  {typeof poweredBy.text !== 'undefined' &&
                    poweredBy.text !== '' && (
                      <div className={s.morecityhover}>
                        {poweredBy.text}
                        <i />
                        {typeof poweredBy.more !== 'undefined' &&
                          poweredBy.more.length && (
                            <div className={s.morelistdrpdown}>
                              <ul>
                                {poweredBy.more.map(item => (
                                  <li>{item.name}</li>
                                ))}
                              </ul>
                            </div>
                          )}
                      </div>
                    )}
                </div>
              )}
            </div>
            <div className={s.column}>
              {/* <WithTimesPoint isWapView={false} /> */}
              <Login
                isMobile={false}
                query={this.props.query}
                pageType={this.props.pageType}
                isEtimes
              />
              <WithNotificationCenter theme="home" colorTheme={colorTheme} />
              <div className={s.etimesgetapp}>
                <a
                  href="https://timesofindia.indiatimes.com/etimesapp.cms"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className={s.appleicon} />
                  <i className={s.androidicon} />
                </a>
              </div>
              <WithSocials colorTheme={colorTheme} />
              {/* <ErrorBoundary>
                <WithGeo
                  render={({ geoCountry }) => (
                    <WithTimesPointModal
                      isWapView={false}
                      disablePrimeFlow={geoCountry !== 'IN'}
                      hideTimesPointPopup={this.props.hideTimesPointPopup}
                      noBaseCss={false}
                    />
                  )}
                />
              </ErrorBoundary> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TopBar.propTypes = {
  //hideTimeStamp: PropTypes.bool,
  query: PropTypes.shape({}),
  // isWapView: PropTypes.bool,
  //editionSwitch: PropTypes.shape({}),
  hideTimesPointPopup: PropTypes.bool,
  colorTheme: PropTypes.string,
  // showWeatherInC: PropTypes.bool,
  pageType: PropTypes.string,
};
TopBar.defaultProps = {
  //hideTimeStamp: false,
  query: {},
  // isWapView: false,
  //editionSwitch: undefined,
  hideTimesPointPopup: false,
  colorTheme: '',
  // showWeatherInC: false,
  pageType: '',
};

export default TopBar;
